import { ZoomableImage } from '@components/image/ZoomableImage';
import { Modal } from '@components/modal';
import { CSSProperties, ReactElement } from 'react';

export const FullScreenImageModal = ({
  url,
  overlaySVG,
  overlayStyle,
  open,
  onClose,
}: {
  url: string;
  overlayStyle?: CSSProperties;
  overlaySVG?: (imageDimensions: [number, number], imageRatio: [number, number]) => ReactElement;
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal open={open} onClose={onClose} sx={{ width: '95vw', height: '95vh' }}>
      <div style={{ width: '100%', height: '100%' }}>
        <ZoomableImage url={url} overlaySVG={overlaySVG} overlayStyle={overlayStyle} showControls />
      </div>
    </Modal>
  );
};
